import { memo } from 'react';

import GET_ALL_UNIT_OF_MEASURE from '@graphql/getAllUnitOfMeasure';

import SelectLazy from '../SelectLazy';

function SelectUnitOfMeasure(props) {
  const renderOptions = (data) => (data || []).map((d) => ({
    value: d.Id,
    label: `[${d.Code}] ${d.Description}`,
  }));

  return (
    <SelectLazy
      {...props}
      placeholder="Select Unit of Measure"
      customRender={renderOptions}
      query={GET_ALL_UNIT_OF_MEASURE}
    />
  );
}

export default memo(SelectUnitOfMeasure);
